import { render, staticRenderFns } from "./PreviewComponentsManager.vue?vue&type=template&id=2805dbde&"
import script from "./PreviewComponentsManager.vue?vue&type=script&lang=js&"
export * from "./PreviewComponentsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports